import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';

import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-common-answers-to-1099R-faq'
    backgroundVariant='lightB'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          align='center'>
          Form 1099&#8211;R:
        </Typography>
        <Accordion
          id='faq-common-1099R-faq'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          addFAQPageSchemaItemType={false}
          items={[
            {
              id: 'life-insurance-faq-report-taxable-gain-faq',
              title: <>How should the taxable gain on Form 1099&#8211;R be reported 	&#45;&#45; ordinary income or capital gains&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  Generally, the gain reported on the full or partial distribution of a life insurance or annuity contract is considered ordinary income. There are some situations in which the proceeds are treated as capital gain, e.g. the life insurance contract was sold by an owner to another party. If you feel your transaction may qualify for capital gain treatment you should consult with your tax advisor.
                </Typography>
              ),
            },
            {
              id: 'life-insurance-faq-taxable-amount-1099R-faq',
              title: <>How is the taxable amount reported on the Form 1099&#8211;R determined for a life insurance
                contract&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    For any part of a transaction to be taxable, the contract must first have a gain. A life insurance
                    contract has a gain when the gross cash value exceeds the cost basis &#40;generally premiums paid less
                    adjustments&#41; of the contract.
                  </Typography>
                  <Typography nextElement='typography'>
                    Generally, when a taxpayer takes a distribution from a life insurance contract the IRC allows the taxpayer to recover the cost basis before any gain is withdrawn, but there are some exceptions. Distributions &#40;including loans&#41; from life insurance contracts classified as Modified Endowment Contracts under the IRC are taxed gain&#45;out	&#45;first. Also, distributions from a contract within the first 15 contract years may be subject to gain&#45;out&#45;first taxation depending on the size of the
                    withdrawal and other factors.
                  </Typography>
                </>
              ),
            },
            {
              id: 'life-insurance-faq-gross-distribution-faq',
              title: <>There was a loan on my life insurance contract when it was surrendered&#47;lapsed. Why is the gross distribution on the Form 1099&#8211;R greater than the amount I received at that time&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  The IRS requires that if a loan is outstanding when a life insurance contract is surrendered or lapses, the taxable amount reported is generally determined by comparing the gross cash value of the contract to the remaining cost basis. The transaction is reported as if the gross cash value were distributed at the time of the surrender or lapse and then used to pay off the loan&#59; value, if any, is distributed to the contract owner.
                </Typography>
              ),
            },
            {
              id: 'life-insurance-faq-forms-for-exchange-in-insurance-faq',
              title: <>I exchanged my life insurance contract for another life insurance contract. Why did I receive a Form 1099&#8211;R &#40;or possibly two Forms 1099&#8211;R&#41;&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    The IRC allows certain exchanges &#40;section 1035 tax&#45;free exchanges&#41;, to occur without generating taxable income even though one contract is surrendered for another.
                  </Typography>
                  <BulletedList
                    bulletedListData={[
                      { bulletText: <>If you exchanged your Northwestern Mutual contract for one with a different company, and the exchange qualified as an IRC section 1035 tax&#45;free exchange, a Form 1099&#8211;R was generated showing a Distribution Code of &#34;6&#34; in Box 7. This provides the cost basis transferred &#40;amount in Box 5&#41; to your new contract as part of the exchange. No taxable amount is reported in Box 2.</> },
                      { bulletText: <>If you received two Forms 1099&#8211;R for the same contract on the exchange from Northwestern Mutual to another company, the exchange was not entirely tax&#45;free. One Form 1099&#8211;R will report the amount of taxable income generated from the exchange &#40;Distribution Code of &#34;7&#34; in Box 7&#41;, which occurs if you received cash or an outstanding loan was extinguished as part of the exchange. The other Form 1099&#8211;R reports the cost basis transferred &#40;Distribution Code of &#34;6&#34; in Box 7&#41; to the new company. If you exchanged one Northwestern Mutual contract for another Northwestern Mutual contract under IRC section 1035, we do not send a 1099&#8211;R with a Distribution Code of &#34;6&#34;as Northwestern Mutual tracks the cost basis internally.</> },
                      { bulletText: <>If your contract did not qualify for the exchange, the surrender was taxable to the extent of the gain and reported on Form 1099&#8211;R with a Distribution Code of &#34;7&#34; in Box 7.</> },
                      { bulletText: 'Variable annuity contracts' },
                    ]}
                  />
                </>
              ),
            },
            {
              id: 'life-insurance-faq-surrender-multi-life-insurance-contracts-faq',
              title: <>I surrendered multiple life insurance or annuity contracts. Why did I only receive one Form 1099&#8211;R&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  The IRS allows for consolidating information from multiple contracts on one form, if the information is similar. As a mutual insurance company that is owned by the policyowners, we take advantage of this opportunity to reduce costs. We do include a breakdown by contract on the page following the Form 1099&#8211;R.
                </Typography>
              ),
            },
            {
              id: 'life-insurance-faq-reporting-what-is-taxable-faq',
              title: <>I received a Form 1099&#8211;R reporting all or part of my annual dividend on my life insurance or annuity contract as taxable. Why&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  Generally, for life insurance, the IRC allows the taxpayer to recover the cost basis of the contract before anything is taxable. If the cost basis was recovered through previous withdrawals, then subsequent dividends that are paid in cash, applied to a contract loan, or deposited into a Billing Account are reported as taxable income. Dividends from an annuity are fully taxable.
                </Typography>
              ),
            },
            {
              id: 'life-insurance-faq-reported-dividend-faq',
              title: <>My contract dividend was reported as taxable&#59; shouldn't that dividend have been reported on Form 1099&#8212;DIV&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  No, per the IRS instructions, taxable dividend distributions from life insurance and annuity
                  contracts are reported on Form 1099&#8211;R &#45; Distributions From Pensions, Annuities, &#8230;Insurance Contracts, etc. The Form 1099&#45;DIV is generally used for dividends paid on corporate stock.
                </Typography>
              ),
            },
            {
              id: 'life-insurance-faq-1099-correction-faq',
              title: <>I received a Form 1099&#8211;R with a Distribution Code of &#34;1&#34; in Box 7 indicating that I am subject to a penalty tax because at the time of the distribution I was younger than age 59&#189;. While I was younger than 59 &#189;, I was also disabled and should qualify for an exception under IRC section 72. Can this Form 1099&#8211;R be corrected&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  While you may qualify for the disability exception, the definition of disability can vary and to qualify you must meet the IRS definition of disability. Northwestern Mutual is not in the position to make the determination of whether you qualify under the IRS definition. You should consult with a tax advisor regarding claiming the exception on your federal tax return.
                </Typography>
              ),
            },
            {
              id: 'life-insurance-faq-incorrect-info-1099R-faq',
              title: <>What should I do if I think some of the information on my 1099&#45;INT&#47;1099&#8211;R is incorrect&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    Information believed to be incorrect:
                  </Typography>
                  <BulletedList
                    bulletedListData={[
                      { bulletText: 'Social Security Number or Taxpayer Identification Number' },
                      { bulletText: 'Address' },
                      { bulletText: 'Your tax form was submitted to the state of your secondary residence, rather than your resident state.' },
                    ]}
                  />
                  <Typography nextElement='typography'>
                    Call the telephone number on the upper right&#45;hand corner of the Instructions for Recipient page that was sent along with your 1099.
                  </Typography>
                  <Typography nextElement='typography'>
                    Information believed to be incorrect:
                  </Typography>
                  <BulletedList
                    bulletedListData={[
                      { bulletText: 'Dollar amounts' },
                      { bulletText: 'Distribution Code' },
                    ]}
                  />
                  <Typography nextElement='typography'>
                    If the information relates to an amount or distribution code, you can call the number on the Instructions for Recipient page as well. However, prior to doing so, please consider:
                  </Typography>
                  <Typography nextElement='typography'>
                    In some instances the information on the 1099 may be combined from multiple policies&#47;contracts or transactions and may account for an apparent discrepancy&#8212;consider all of the transactions that were completed during the tax year.
                  </Typography>
                  <Typography nextElement='typography'>
                    The reporting and determination of taxable income from life insurance policy and annuity contract is governed by Internal Revenue Code, and not a contractual stipulation on the part of Northwestern   Mutual. Northwestern Mutual is required by law to report certain taxable transactions from life insurance policies and annuity contracts.
                  </Typography>
                  <Typography nextElement='typography'>
                    There may be instances where Northwestern Mutual is required to report a transaction as taxable in a certain manner, but for reasons not reflected in Northwestern Mutual's records, the distribution may qualify for different tax treatment. In these situations you may need to provide additional information to the Internal Revenue Service &#40;not Northwestern Mutual&#41; to support your position regarding the amount of income that is taxable. Northwestern Mutual cannot determine the impact of transactions that are not fully reflected in our records. You should seek tax advice from a tax advisor.
                  </Typography>
                  <Typography
                    component='small'
                    nextElement='typography'>
                    This FAQ is not intended to be tax advice and cannot be used for the purpose of avoiding
                    penalties that may be imposed under the Internal Revenue Code or any other applicable tax law and you are advised to seek tax advice based upon your own particular circumstances from an independent tax advisor.
                  </Typography>
                  <Typography
                    component='small'
                    nextElement='typography'>
                    Effective tax year 2020, the IRS has made changes to tax form 1099MISC by removing Non&#45;Employee Compensation &#40;NEC&#41; to its own 1099NEC form. To see further detail regarding IRS tax forms, please visit <Link
                      linkUrl="https://www.irs.gov/" isOutgoingLink variant='primaryDeemphasize'>IRS.gov</Link> or consult with your professional tax advisor.
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
